import Vue from 'vue'
import DlgDraggable from 'vue-element-dialog-draggable'
import selectSortableDirective from '@/directives/select-sortable'
import autoCloseMsg from '@/plugins/autoCloseMsg'
import transComplex from '@/plugins/transComplex'
import autoHeightDirective from '@/directives/auto-height'
import components from '@/components'
import { toPreview } from '@/utils/fileUtil'
import { STATUS_CODE, CP_TYPE } from '@/utils/constants'

import filters from '@/filters'
import { i18n } from '@/i18n'

import '@/utils/installElementUI'

/**
 * 给 Vue 实例添加方法或者挂载到 Vue 对象上
 * 或者引入插件
 */
export function patchVue() {
  Vue.use(DlgDraggable, {})
  Vue.use(autoCloseMsg)
  Vue.use(components)
  Vue.use(autoHeightDirective)
  Vue.use(transComplex)

  Vue.use(selectSortableDirective)

  /* ======== 添加自定义的方法/属性 ======= */

  Vue.prototype.$STATUS_CODE = STATUS_CODE
  Vue.prototype.$toPreview = toPreview
  Vue.use(filters)

  Vue.i18n = i18n
  Vue.$QC = QC // eslint-disable-line

  // qq登录全局对象
  Vue.prototype.$QC = QC // eslint-disable-line
  Vue.prototype.$CONST = {
    CP_TYPE: CP_TYPE
  }
}
